import { render, staticRenderFns } from "./CaixaEntrada.vue?vue&type=template&id=ec614c64&scoped=true&lang=pug"
import script from "./CaixaEntrada.vue?vue&type=script&lang=js"
export * from "./CaixaEntrada.vue?vue&type=script&lang=js"
import style0 from "./CaixaEntrada.vue?vue&type=style&index=0&id=ec614c64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec614c64",
  null
  
)

export default component.exports